<div *ngIf="customer" class="row pt-4">
  <div class="col-12 col-md-6">
    <div class="form-group">
      <label class="control-label" for="city" translate>NAME</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="customer.extra._billing.ftgnamn"
        disabled
      />
    </div>
    <div class="form-group">
      <label class="control-label" for="address" translate>FR_FTGPOSTADR1</label>
      <input
        class="form-control"
        name="address"
        type="text"
        [(ngModel)]="customer.extra._billing.ftgpostadr1"
        disabled
      />
    </div>

    <div class="form-group">
      <label class="control-label" for="city" translate>FR_FTGPOSTADR2</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="customer.extra._billing.ftgpostadr2"
        disabled
      />
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="form-group">
      <label class="control-label" for="city" translate>FR_FTGPOSTNR</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="customer.extra._billing.ftgpostnr"
        disabled
      />
    </div>
    <div class="form-group">
      <label class="control-label" for="city" translate>FR_FTGPOSTADR3</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="customer.extra._billing.ftgpostadr3"
        disabled
      />
    </div>
    <div class="form-group">
      <label class="control-label" for="city" translate>FR_LANDSKOD</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="customer.extra._billing.landskod"
        disabled
      />
    </div>
  </div>
</div>
